import { NS } from "../common/classes";

export const SELECT_EMPTY = `${NS}-select-empty`;
export const SELECT_OPTIONS = `${NS}-select-options`;
export const SELECT_OPTION = `${NS}-select-option`;
export const SELECT_OPTION_TEMP = `${NS}-select-option-temp`;
export const SELECT_EMPTY_TEMP = `${NS}-select-empty-temp`;
